import React from 'react';
import PropTypes from 'prop-types';
import { theme } from '../../../tailwind.theme';

export class HeaderGradient extends React.PureComponent {
	static propTypes = {
		isFullWidth: PropTypes.bool,
		noMargins: PropTypes.bool,
		style: PropTypes.object
	}

	render() {
		const { isFullWidth, noMargins , style: styleFromProps} = this.props;
		const {
			extend: {
				colors: {
					scienceBlue,
					scienceBlueTransparent,
					scienceBlueSemiTransparent
				}
			}
		} = theme;

		let className = `w-3/4 absolute bottom-0 left-0 ${
			noMargins ? '' : 'mb-8'
		} ml-8 mr-64`;

		if (isFullWidth) {
			className = `w-full absolute bottom-0 left-0 ${
				noMargins ? '' : 'mb-4'
			}`;
		}

		const endColor = isFullWidth
			? scienceBlueSemiTransparent
			: scienceBlueTransparent;

		const style = {
			height: '2px',
			backgroundImage: `linear-gradient(to right, ${scienceBlue}, ${endColor})`
		};

		return (
			<div
				className={className}
				style={{...style, ...styleFromProps}} />
		);
	}
}
